import React from 'react';
import { ConditionsReview } from './pages/ConditionsReview';
export function App() {
  return <ConditionsReview data-id="element-0" />;
}